export default function SearchService($http, API_SERVER, Log) {
    var fn = this;

    /**
     * API V3
     */

    fn.groupedByWeeks = (start, weeks, activityId, locationId, isFixed) => {
        // Endpoint:
        const endpoint = `/search/:grouped_by_weeks`;

        const params = `?start=${start}&weeks=${weeks}&activityId=${activityId}&locationId=${locationId}&isFixed=${isFixed}`;

        const url = API_SERVER + endpoint + params;

        Log.endpoint(endpoint, url);

        const headers = {
            endpointType: "noTokenRequired", // used by interceptor to skip access token
        };

        return $http.get(url, { headers: headers }).then((res) => {
            return res.data;
        });
    };

    fn.checkAvailability = (
        start,
        weeks,
        activityId,
        resourceId,
        isFixed,
        startTime,
        endTime
    ) => {
        // Endpoint:
        const endpoint = `/search/:check_availability`;

        const params =
            `?start=${start}` +
            `&weeks=${weeks}` +
            `&activityId=${activityId}` +
            `&resourceId=${resourceId}` +
            `&isFixed=${isFixed}` +
            `&startTime=${startTime}` +
            `&endTime=${endTime}`;

        const url = API_SERVER + endpoint + params;

        Log.endpoint(endpoint, url);

        return $http.get(url).then((res) => {
            return res.data;
        });
    };

    return fn;
}
